import { RootState } from "@/shared/types";

import { IDialogSettings } from "./types/interfaces";

export const selectSettings = (state: RootState): IDialogSettings =>
  state.dialog.settings;

export const selectIsLoading = (state: RootState): boolean =>
  state.dialog.isLoading;
